// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nd-c";
export var backButton = "_nd-4";
export var backIcon = "_nd-5";
export var chevronShortcut = "_nd-6";
export var container = "_nd-1";
export var editor = "_nd-8";
export var editorWrapper = "_nd-7";
export var prefix = "_nd-2";
export var searchIcon = "_nd-3";
export var suffix = "_nd-9";
export var suffixContent = "_nd-a";
export var suffixText = "_nd-b";
export var wrapper = "_nd-0";